module.exports = __webpack_public_path__ + "static/img/office-discussion.1ae68d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/module-test-page/assets/office-discussion.jpg
// module id = J3uG
// module chunks = 1